/**
 * Normalize URL paths so analytics events aggregate by route shape rather than
 * exact identifier. Stripping IDs prevents both high-cardinality dashboard
 * blow-up and incidental leakage of internal record keys into analytics.
 */
const ID_PATTERNS: readonly RegExp[] = [
  // RFC 4122 UUIDs
  /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
  // 24-char hex Mongo ObjectIds
  /\/[0-9a-f]{24}(?=\/|$)/gi,
  // Numeric IDs of 4+ digits (4 chosen so /v1, /q3 etc. survive)
  /\/\d{4,}(?=\/|$)/g,
];

export const scrubRoute = (path: string): string => {
  if (typeof path !== 'string' || path.length === 0) {
    return path;
  }
  return ID_PATTERNS.reduce((p, re) => p.replace(re, '/[id]'), path);
};
